import React, { FunctionComponent } from "react";
import { Grid, Box, Card, CardContent, Stack } from "@mui/material";
import { CustomBreadCrumbs, PageHeader, CustomInput, CustomSelect, CustomDatePicker, Button } from "../../components";
import { CustomTextArea } from "../../components/CustomTextArea";
import { LeadRefundForm } from "../../components/LeadRefundForm";
import { mdiHome } from "@mdi/js"

export const LeadRefund = (): JSX.Element => {
    return (
        <>
            <Grid xs={12} sx={{ mb: 2 }}>
                <CustomBreadCrumbs icon={mdiHome} path="Home/Refund" />
            </Grid>
            <PageHeader
                title="Lead Refund Form"
                subTitle={`In order to request a refund for a lead, please provide the following information for review.\nAll fields are required to submit a refund request successfully`}
            />
            <Box mt={4}>
                <LeadRefundForm />
            </Box>
        </>
    )
}